import createAPIRequest from '../helpers/createAPIRequest'
import useSpellCall from './useSpellCall'

//-----------
// edit spell
//-----------
export default async function useEditStaticSpell(spellRequest) {
  const payload = { ...(spellRequest?.payload ?? {}) }
  const lookup = spellRequest?.id ?? payload.id ?? ''

  const request = createAPIRequest({
    endpoint: 'api/v1/spells/',
    // createAPIRequest names this field slug for legacy callers;
    // static spell detail routes use the UUID id as the lookup value.
    slug: lookup,
    partialInd: !!spellRequest?.partial,
    deleteInd: spellRequest?.action === 'DELETE',
  })

  return useSpellCall({
    api_request: request,
    payload,
  })
}
